import { BusinessBasic, WorkingHour, BookingType, Staff, BusinessData, WorkingHourGroup } from "../../types"; 

// Actions
export enum BusinessActionTypes {
  ADD_BUSINESS = "ADD_BUSINESS",
  ADD_BUSINESSES = "ADD_BUSINESSES",
  UPDATE_BUSINESS_BASIC = "UPDATE_BUSINESS_BASIC", 

  UPDATE_WORKING_HOUR_GROUP = "UPDATE_WORKING_HOUR_GROUP", 
  UPDATE_BUSINESS_WORKING_HOUR = "UPDATE_BUSINESS_WORKING_HOUR", 
  UPDATE_WORKING_GROUP ="UPDATE_WORKING_GROUP",

  ADD_STAFF = "ADD_STAFF",
  UPDATE_STAFF = "UPDATE_STAFF",
  DELETE_STAFF = "DELETE_STAFF",
  UPDATE_STAFF_WORKING_HOUR = "UPDATE_STAFF_WORKING_HOUR",

  UPDATE_BUSINESS_SERVICE = "UPDATE_BUSINESS_SERVICE",
  DELETE_BUSINESS_SERVICE = "DELETE_BUSINESS_SERVICE",

  SET_SELECTED_BUSINESS = "SET_SELECTED_BUSINESS",

  UPDATE_BOOKING_TYPE = "UPDATE_BOOKING_TYPE",
  DELETE_BOOKING_TYPE = "DELETE_BOOKING_TYPE", 
}

export interface AddBusinessAction {
  type: BusinessActionTypes.ADD_BUSINESS;
  payload: {
    businessData: BusinessData;
  };
}

export const addBusiness = (businessData: BusinessData): AddBusinessAction => ({
  type: BusinessActionTypes.ADD_BUSINESS,
  payload: { businessData },
});


export interface AddBusinessesAction {
  type: BusinessActionTypes.ADD_BUSINESSES;
  payload: {
    businesses: BusinessData[];
  };
}

export const addBusinesses = (businesses: BusinessData[], source: "MY_BUSINESSES" | "ALL_BUSINESSES") => ({
  type: BusinessActionTypes.ADD_BUSINESSES,
  payload: { businesses, source },
});

export interface updateBusinessAction {
  type: BusinessActionTypes.UPDATE_BUSINESS_BASIC;
  payload: {
    businessId: number;
    businessBasic: BusinessBasic;
  };
}

export const updateBusiness = (
  businessId: number,
  businessBasic: BusinessBasic
): updateBusinessAction => ({
  type: BusinessActionTypes.UPDATE_BUSINESS_BASIC,
  payload: { businessId, businessBasic },
}); 

export enum WorkingHourOperation {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum EntityType {
  STAFF = 'STAFF',
  BUSINESS = 'BUSINESS', 
}

export interface UpdateBusinessWorkingHourAction {
  type: BusinessActionTypes.UPDATE_BUSINESS_WORKING_HOUR;
  payload: {
    businessId: number; 
    workingHour: WorkingHour;
    operation: WorkingHourOperation
  };
} 

export const updateBusinessWorkingHour = (
  businessId: number, 
  workingHour: WorkingHour,
  operation: WorkingHourOperation // Add operation as a parameter
): UpdateBusinessWorkingHourAction => ({
  type: BusinessActionTypes.UPDATE_BUSINESS_WORKING_HOUR,
  payload: { businessId, workingHour, operation },
}); 

 
export interface AddStaffAction {
  type: BusinessActionTypes.ADD_STAFF;
  payload: {
    businessId: number;
    staffs: Staff[];
  };
} 

export const addStaff = (
  businessId: number,
  staffs: Staff[]
): AddStaffAction => ({
  type: BusinessActionTypes.ADD_STAFF,
  payload: { businessId, staffs },
});

export interface UpdateStaffAction {
  type: BusinessActionTypes.UPDATE_STAFF;
  payload: {
    businessId: number;
    staff: Staff;
  };
} 

export const updateStaff = (
  businessId: number,
  staff: Staff
): UpdateStaffAction => ({
  type: BusinessActionTypes.UPDATE_STAFF,
  payload: { businessId, staff },
});

export interface UpdateBusinessBookingTypeAction {
  type: BusinessActionTypes.UPDATE_BUSINESS_SERVICE;
  payload: {
    businessId: number;
    businessBookingType: BookingType;
  };
}


export interface UpdateStaffWorkingHoursAction {
  type: BusinessActionTypes.UPDATE_STAFF_WORKING_HOUR;
  payload: {
    businessId: number;
    staffId: number;
    updatedWorkingHours: WorkingHour[]; // Array for multiple working hour records
    workingHourGroup: WorkingHourGroup; // Include full group data when adding new group
    operation: WorkingHourOperation;
  };
}

export const updateStaffWorkingHour = (
  businessId: number,
  staffId: number,
  updatedWorkingHours: WorkingHour[],
  workingHourGroup: WorkingHourGroup,
  operation: WorkingHourOperation
): UpdateStaffWorkingHoursAction => ({
  type: BusinessActionTypes.UPDATE_STAFF_WORKING_HOUR,
  payload: { businessId, staffId, updatedWorkingHours, workingHourGroup, operation },
});

export interface UpdateWorkingHourGroupsAction {
  type: BusinessActionTypes.UPDATE_WORKING_GROUP;
  payload: {
    staffId: number,
    businessId: number, 
    workingHourGroup: WorkingHourGroup; // Include full group data when adding new group
    operation: WorkingHourOperation;
  };
}

export const updateWorkingHourGroup = (
  staffId: number,
  businessId: number, 
  workingHourGroup: WorkingHourGroup,
  operation: WorkingHourOperation
): UpdateWorkingHourGroupsAction => ({
  type: BusinessActionTypes.UPDATE_WORKING_GROUP,
  payload: {staffId,businessId, workingHourGroup, operation },
}); 


export const updateBusinessBookingType = (
  businessId: number,
  businessBookingType: BookingType
): UpdateBusinessBookingTypeAction => ({
  type: BusinessActionTypes.UPDATE_BUSINESS_SERVICE,
  payload: { businessId, businessBookingType },
});



export interface UpdateBookingTypeAction {
  type: BusinessActionTypes.UPDATE_BOOKING_TYPE;
  payload: {
    businessId: number;
    bookingType: BookingType;
    assignedStaffs: Staff[]
  };
}

export const updateBookingType = (
  businessId: number,
  bookingType: BookingType,
  assignedStaffs: Staff[]
): UpdateBookingTypeAction => ({
  type: BusinessActionTypes.UPDATE_BOOKING_TYPE,
  payload: { businessId, bookingType, assignedStaffs },
});



export interface DeleteStaffAction {
  type: BusinessActionTypes.DELETE_STAFF;
  payload: {
    businessId: number;
    staffId: number;
  };
}

export const deleteStaff = (
  businessId: number,
  staffId: number
): DeleteStaffAction => ({
  type: BusinessActionTypes.DELETE_STAFF,
  payload: { businessId, staffId },
});

export interface deleteBookingTypeAction {
  type: BusinessActionTypes.DELETE_BUSINESS_SERVICE;
  payload: {
    businessId: number;
    bookingTypeId: number;
  };
}

export const deleteBookingType = (
  businessId: number,
  bookingTypeId: number
): deleteBookingTypeAction => ({
  type: BusinessActionTypes.DELETE_BUSINESS_SERVICE,
  payload: { businessId, bookingTypeId },
});

export interface SetSelectedBusinessAction {
  type: BusinessActionTypes.SET_SELECTED_BUSINESS;
  payload: number;
}

export const setSelectedBusiness = (
  businessId: number
): SetSelectedBusinessAction => ({
  type: BusinessActionTypes.SET_SELECTED_BUSINESS,
  payload: businessId,
});
